import { h } from 'vue';
import { message } from 'ant-design-vue';
import {
    CheckCircleFilled,
    CloseCircleFilled,
    ExclamationCircleFilled,
    InfoCircleFilled
} from '@ant-design/icons-vue';

const ICONES = {
    success: CheckCircleFilled,
    error: CloseCircleFilled,
    warning: ExclamationCircleFilled,
    info: InfoCircleFilled
};

export default class NewMessage {

    static show(vm, type, title, description = '', duration = 5) {
        // Permite:
        // NewMessage.info(this, 'Título', 10)
        // onde 10 será duration
        if (typeof description === 'number') {
            duration = description;
            description = '';
        }

        // Vue 3: this.$message continua disponível via app.use(Antd);
        // se não houver, usa o message importado do ant-design-vue
        const $message = (vm && vm.$message) || message;

        let closeMessage = null;

        const content = h(
            'div',
            {
                class: 'new-message-content',
                style: { display: 'flex', alignItems: 'flex-start' }
            },
            [
                // Ícone à esquerda (a cor vem do próprio antd: .ant-message-<tipo> .anticon)
                h(ICONES[type]),

                h(
                    'div',
                    {
                        style: { flex: 1 }
                    },
                    [
                        // Linha do título + X
                        h(
                            'div',
                            {
                                class: 'new-message-header'
                            },
                            [
                                h(
                                    'span',
                                    {
                                        class: 'new-message-title'
                                    },
                                    title
                                ),

                                h(
                                    'span',
                                    {
                                        class: 'new-message-close',
                                        onClick: () => {
                                            if (typeof closeMessage === 'function') {
                                                closeMessage();
                                            }
                                        }
                                    },
                                    '×'
                                )
                            ]
                        ),

                        // Descrição (aceita HTML)
                        description
                            ? h(
                                'div',
                                {
                                    class: 'new-message-description',
                                    innerHTML: description
                                }
                            )
                            : null
                    ]
                )
            ]
        );

        closeMessage = $message[type]({
            content,
            duration,
            // Esconde o ícone padrão do antd (que ficava em cima do título);
            // o ícone agora é renderizado dentro do conteúdo, ao lado do título
            icon: h('span', { style: { display: 'none' } })
        });

        return closeMessage;
    }


    static success(vm, title, description = '', duration = 5) {
        return this.show(
            vm,
            'success',
            title,
            description,
            duration
        );
    }


    static error(vm, title, description = '', duration = 5) {
        return this.show(
            vm,
            'error',
            title,
            description,
            duration
        );
    }


    static warning(vm, title, description = '', duration = 5) {
        return this.show(
            vm,
            'warning',
            title,
            description,
            duration
        );
    }


    static info(vm, title, description = '', duration = 5) {
        return this.show(
            vm,
            'info',
            title,
            description,
            duration
        );
    }
}
